import React from 'react';
import { Button } from '../shared/Button';
import { CheckIcon } from 'lucide-react';
export const AddOnSection = () => {
  const features = ['Personalized skill evaluation & gap analysis', '5 deep-dive technical sessions', '3 FAANG-style mock interviews', 'Custom technical growth roadmap', 'Language-specific code reviews', 'System design workshops'];
  return <section className="w-full bg-gradient-to-br from-[#1a0d24] to-[#231232] py-24 border-t border-b border-[#6805DA]/20" data-id="element-64" data-mp="bt4vx435xts3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-65" data-mp="6sh5okmrdgyx">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-66" data-mp="1u5x0d879cia">
          <div data-id="element-67" data-mp="1unz3qhjmky4">
            <h2 className="text-4xl font-outfit font-bold mb-6 text-white" data-id="element-68" data-mp="1w8utjflg9xk">
              1:1 Technical Coaching Add-On
            </h2>
            <p className="text-xl text-gray-300 mb-8" data-id="element-69" data-mp="1w8p1glcaxq2y">
              10 tailored sessions with FAANG engineers. Includes skill
              evaluation, 5 deep dives, 3 mock interviews, and a final technical
              roadmap. Perfect for TPMs or FAANG/quant prep.
            </p>
            <div className="space-y-4 mb-8" data-id="element-70" data-mp="1fh1fkjbbx4cj">
              {features.map(feature => <div key={feature} className="flex items-start" data-id="element-71" data-mp="10jhehnhjztbn">
                  <CheckIcon size={20} className="text-white/60 mr-3 mt-1 flex-shrink-0" data-id="element-72" data-mp="10l2cxo6znwes" />
                  <span className="text-white/80" data-id="element-73" data-mp="1t7dcqwmrttaj">{feature}</span>
                </div>)}
            </div>
            <div className="flex items-center gap-6" data-id="element-74" data-mp="1y5oj2xduxlo0">
              <Button variant="primary" href="/start" data-id="element-75" data-mp="1ji3gd4kw9ogm">
                Learn More
              </Button>
            </div>
          </div>
          <div className="bg-white/5 backdrop-blur-sm p-1 rounded-xl border border-white/10" data-id="element-76" data-mp="1og50ztxyxvu7">
            <div className="bg-[#231232]/90 backdrop-blur-sm rounded-lg p-6" data-id="element-77" data-mp="2c5pw1b7ecjju">
              <h3 className="text-2xl font-outfit font-bold mb-6 text-white" data-id="element-78" data-mp="2gy0vkcy863bv">
                Technical Assessment Areas
              </h3>
              <div className="space-y-6" data-id="element-79" data-mp="2qsxztqydlmls">
                <div data-id="element-80" data-mp="2luda4lgr2lbl">
                  <h4 className="text-white/80 font-semibold mb-2" data-id="element-81" data-mp="2ltv3cuwgoopf">
                    System Design & Architecture
                  </h4>
                  <div className="w-full bg-white/5 rounded-full h-2" data-id="element-82" data-mp="2hqyi0wfjeehs">
                    <div className="bg-gradient-to-r from-white/20 to-white/10 h-2 rounded-full w-4/5" data-id="element-83" data-mp="2csn9cp0zaa15" />
                  </div>
                </div>
                <div data-id="element-84" data-mp="27wgdjp2aqewx">
                  <h4 className="text-white/80 font-semibold mb-2" data-id="element-85" data-mp="2345bognzwj1q">
                    Data Structures & Algorithms
                  </h4>
                  <div className="w-full bg-white/5 rounded-full h-2" data-id="element-86" data-mp="1y5lm86a70p4m">
                    <div className="bg-gradient-to-r from-white/20 to-white/10 h-2 rounded-full w-3/5" data-id="element-87" data-mp="1u404a6isxknk" />
                  </div>
                </div>
                <div data-id="element-88" data-mp="1p66znhx5cype">
                  <h4 className="text-white/80 font-semibold mb-2" data-id="element-89" data-mp="1k514ldg0kzcp">
                    Code Quality & Best Practices
                  </h4>
                  <div className="w-full bg-white/5 rounded-full h-2" data-id="element-90" data-mp="3vrbgho9ip4md">
                    <div className="bg-gradient-to-r from-white/20 to-white/10 h-2 rounded-full w-4/5" data-id="element-91" data-mp="4lk2fn90lifx" />
                  </div>
                </div>
                <div data-id="element-92" data-mp="9lxzybczp9zp">
                  <h4 className="text-white/80 font-semibold mb-2" data-id="element-93" data-mp="9jbuqidkn6kn">
                    Technical Communication
                  </h4>
                  <div className="w-full bg-white/5 rounded-full h-2" data-id="element-94" data-mp="3d2oa92flu977">
                    <div className="bg-gradient-to-r from-white/20 to-white/10 h-2 rounded-full w-3/4" data-id="element-95" data-mp="3i0zkhe9talpy" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};